/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	EnrollmentDTO,
	EnrollmentDTOFromJSON,
	EnrollmentDTOFromJSONTyped,
	EnrollmentDTOToJSON,
} from "./EnrollmentDTO";

/**
 *
 * @export
 * @interface EnrollmentDTOPagedResponse
 */
export interface EnrollmentDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof EnrollmentDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EnrollmentDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EnrollmentDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<EnrollmentDTO>}
	 * @memberof EnrollmentDTOPagedResponse
	 */
	data?: Array<EnrollmentDTO> | null;
}

export function EnrollmentDTOPagedResponseFromJSON(
	json: any
): EnrollmentDTOPagedResponse {
	return EnrollmentDTOPagedResponseFromJSONTyped(json, false);
}

export function EnrollmentDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EnrollmentDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(EnrollmentDTOFromJSON),
	};
}

export function EnrollmentDTOPagedResponseToJSON(
	value?: EnrollmentDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(EnrollmentDTOToJSON),
	};
}
